import styled from "@emotion/styled";
import { darken } from "polished";
import { appColorWarning } from "@assets/styles/colors";

export const StyledMarkerZone = styled.div<{
  width: string;
  height: string;
  transform: string;
  transformOrigin: string;
  isVisible?: boolean;
  isModeLinking?: boolean;
}>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  display: block;
  width: 100%;
  height: 100%;
  text-indent: -9999px;

  ${({ isModeLinking }) =>
    isModeLinking
      ? `
        display: block;

        &:before {
            content: "";
          }

        &:hover {
          &:before {
            border-color: ${darken("0.15", appColorWarning)};
            cursor: pointer;
          }
        }
      `
      : ""}

  ${({ width, height, transform, transformOrigin }) => ({ width, height, transform, transformOrigin })}
  ${({ isVisible }) => (isVisible ? "" : `visibility: hidden;`)}

  &:before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border: 3px solid ${appColorWarning};
  }
`;
